import React from 'react';
import { useMediaQuery } from 'react-responsive';
export const WebMediaQuery = ({ mobileOnly, desktopOnly, largeDesktopOnly, children, }) => {
    const isLargeDesktopOnly = useMediaQuery({ query: 'screen and (min-width : 1024px)' });
    const isDesktopOnly = useMediaQuery({ query: 'screen and (min-width : 769px)' });
    const isMobileOnly = useMediaQuery({ query: 'screen and (max-width : 768px)' });
    const isDefault = useMediaQuery({ query: 'screen' });
    if (isLargeDesktopOnly && largeDesktopOnly) {
        return React.createElement(React.Fragment, null, children);
    }
    if (isDesktopOnly && desktopOnly) {
        return React.createElement(React.Fragment, null, children);
    }
    if (isMobileOnly && mobileOnly) {
        return React.createElement(React.Fragment, null, children);
    }
    if (!largeDesktopOnly && !desktopOnly && !mobileOnly) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(React.Fragment, null);
};
